export default "__VITE_ASSET__B8bmC5AG__"